import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "information-form-wrapper" }
const _hoisted_2 = { class: "block" }
const _hoisted_3 = { class: "font-bold" }
const _hoisted_4 = { class: "block" }
const _hoisted_5 = { class: "font-bold" }
const _hoisted_6 = { class: "block" }
const _hoisted_7 = { class: "font-bold" }
const _hoisted_8 = { class: "block" }
const _hoisted_9 = { class: "font-bold" }
const _hoisted_10 = { class: "block" }
const _hoisted_11 = { class: "font-bold" }
const _hoisted_12 = { class: "font-bold text-sm block mt-6" }
const _hoisted_13 = { class: "w-full px-10 pt-10 form-wrapper" }
const _hoisted_14 = { class: "max-w-2xl mx-auto" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h1", { class: "font-bold text-white text-5xl mb-8" }, "Giriş", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "text-white text-sm" }, "Checkup'a başlayabilmek için lütfen aşağıda bulunan formu doldurunuz.", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("hr", { class: "bg-white mb-10 mt-8" }, null, -1)
const _hoisted_18 = { class: "text-white text-base" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Binovative'in ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Açık Rıza Metnini")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" okudum ve kabul ediyorum. ")
const _hoisted_22 = { class: "text-white text-base" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Binovative'in ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Aydınlatma Metnini")
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" okudum ve kabul ediyorum. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_the_checkbox = _resolveComponent("the-checkbox")!
  const _component_the_form = _resolveComponent("the-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_modal, {
      visible: _ctx.sessionModalVisible,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sessionModalVisible) = $event)),
      title: _ctx.$t('information.session-found-title'),
      centered: "",
      closable: false,
      "mask-closable": false,
      "ok-text": _ctx.$t('button.continue'),
      "cancel-text": _ctx.$t('button.cancel'),
      onOk: _ctx.acceptSession,
      onCancel: _ctx.rejectSession
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('form.full-name')) + ":", 1),
            _createTextVNode(" " + _toDisplayString(_ctx.session.name), 1)
          ]),
          _createElementVNode("span", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('form.company-name')) + ":", 1),
            _createTextVNode(" " + _toDisplayString(_ctx.session.companyName), 1)
          ]),
          _createElementVNode("span", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('form.e-mail')) + ":", 1),
            _createTextVNode(" " + _toDisplayString(_ctx.session.email), 1)
          ]),
          _createElementVNode("span", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('form.sector')) + ":", 1),
            _createTextVNode(" " + _toDisplayString(_ctx.session.sector), 1)
          ]),
          _createElementVNode("span", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('form.language')) + ":", 1),
            _createTextVNode(" " + _toDisplayString(_ctx.session.language === _ctx.LanguageEnum.Turkish ? _ctx.$t('common.turkish') : _ctx.$t('common.english')), 1)
          ])
        ]),
        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('information.do-you-want-continue')), 1)
      ]),
      _: 1
    }, 8, ["visible", "title", "ok-text", "cancel-text", "onOk", "onCancel"]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _hoisted_16,
        _hoisted_17,
        _createVNode(_component_the_form, {
          "submit-text": 'common.start',
          submitting: _ctx.submitting,
          class: "mx-auto information-form",
          onSubmit: _ctx.submit
        }, {
          default: _withCtx(() => [
            _createVNode(_component_the_input, {
              value: _ctx.formData.name,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.name) = $event)),
              name: "fullname",
              type: "text",
              label: _ctx.$t('form.full-name'),
              class: "mb-4",
              rules: _ctx.Yup.string().required()
            }, null, 8, ["value", "label", "rules"]),
            _createVNode(_component_the_input, {
              value: _ctx.formData.companyName,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.companyName) = $event)),
              name: "companyName",
              type: "text",
              label: _ctx.$t('form.company-name'),
              class: "mb-4",
              rules: _ctx.Yup.string().required()
            }, null, 8, ["value", "label", "rules"]),
            _createVNode(_component_the_input, {
              value: _ctx.formData.email,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.email) = $event)),
              name: "email",
              type: "text",
              label: _ctx.$t('form.e-mail'),
              class: "mb-4",
              rules: _ctx.Yup.string().email().required()
            }, null, 8, ["value", "label", "rules"]),
            _createVNode(_component_the_select, {
              value: _ctx.formData.sector,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.sector) = $event)),
              label: _ctx.$t('form.sector'),
              name: 'sector',
              class: "mb-4",
              rules: _ctx.Yup.string().required(),
              options: _ctx.sectorOptions
            }, null, 8, ["value", "label", "rules", "options"]),
            _createVNode(_component_the_checkbox, {
              checked: _ctx.formData.acikriza,
              "onUpdate:checked": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.acikriza) = $event)),
              name: "acikriza",
              rules: _ctx.Yup.bool().isTrue(),
              class: "block w-full mb-2"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_18, [
                  _hoisted_19,
                  _createVNode(_component_router_link, {
                    to: '/acik-riza',
                    target: "_blank",
                    class: "underline text-blue-200"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_20
                    ]),
                    _: 1
                  }),
                  _hoisted_21
                ])
              ]),
              _: 1
            }, 8, ["checked", "rules"]),
            _createVNode(_component_the_checkbox, {
              checked: _ctx.formData.aydinlatma,
              "onUpdate:checked": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.aydinlatma) = $event)),
              name: "aydinlatma",
              rules: _ctx.Yup.bool().isTrue(),
              class: "block w-full"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_22, [
                  _hoisted_23,
                  _createVNode(_component_router_link, {
                    to: '/agreements/binovative_kvkk_aydinlatma_metni.pdf',
                    target: "_blank",
                    class: "underline text-blue-200"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_24
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _hoisted_25
                ])
              ]),
              _: 1
            }, 8, ["checked", "rules"])
          ]),
          _: 1
        }, 8, ["submit-text", "submitting", "onSubmit"])
      ])
    ])
  ]))
}